import React, { useState } from 'react';
import logo from '../logo.jpg';
import bgimg from '../img.jpg';
import BookingBar from './BookingBar';
import RestaurantInfo from './RestaurantInfo';
import TimeSlotList from './TimeSlotList';
import Modal from './Modal';
import './HomePage.css';

const getDatesArray = (days = 30) => {
  const arr = [];
  const today = new Date();
  for (let i = 0; i < days; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    arr.push(d);
  }
  return arr;
};

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState({
    time: '',
    type: '',
    date: ''
  });
  const [reservationDetails, setReservationDetails] = useState(null);

  // Фильтры
  const [guestCount, setGuestCount] = useState(2);
  const [selectedDateIdx, setSelectedDateIdx] = useState(0);
  const [selectedTime, setSelectedTime] = useState('All Times');
  const datesArr = getDatesArray(30);

  // Сохранять количество гостей в localStorage
  const handleGuestChange = (count) => {
    setGuestCount(count);
    localStorage.setItem('pierchicGuests', count);
  };

  const handleSelectTimeSlot = (time, type, date) => {
    setSelectedTimeSlot({ time, type, date });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Обработчики для фильтров
  const handleDateChange = (idx) => setSelectedDateIdx(idx);
  const handleTimeChange = (time) => setSelectedTime(time);

  return (
    <div className="home-page">
      <div className="reservation-logo-bar reservation-logo-bar-white">
        <img src={logo} alt="Pierchic Logo" className="reservation-logo-img" />
      </div>
      <center><div className="homepage-header-img" style={{backgroundImage: `url(${bgimg})`}}></div></center>
      <div className="container">
        <BookingBar 
          guestCount={guestCount}
          onGuestChange={handleGuestChange}
          selectedDateIdx={selectedDateIdx}
          onDateChange={handleDateChange}
          selectedTime={selectedTime}
          onTimeChange={handleTimeChange}
          datesArr={datesArr}
        />
        <div className="content-container">
          <TimeSlotList 
            onSelectTimeSlot={handleSelectTimeSlot}
            selectedDate={datesArr[selectedDateIdx]}
            selectedTime={selectedTime}
            guestCount={guestCount}
            onDateChange={handleDateChange}
            selectedDateIdx={selectedDateIdx}
            datesArr={datesArr}
          />
          <RestaurantInfo />
        </div>
        <div className="restaurant-location">JUMEIRAH AL QASR</div>
        <div className="reservation-notice">
          For reservations on this day or group reservations, please call us on +971 4 432 3232
        </div>
      </div>
      <Modal 
        isOpen={isModalOpen} 
        closeModal={closeModal} 
        selectedTimeSlot={selectedTimeSlot}
        setReservationDetails={setReservationDetails}
      />
    </div>
  );
};

export default HomePage; 